import { Controller } from "@hotwired/stimulus";
import { updateSelect } from "shared/selects/select_helpers";

// Connects to data-controller="selects--hierarchical_select"
export class HierarchicalSelectController extends Controller {
    parent = null;
    selectType = null;

    initialize() {
        super.initialize();


    }

    connect() {
        super.connect();
    }

    _dispatchSelectionChangedEvent(event) {


    }

    _dispatchUnselectedEvent(values) {


        window.dispatchEvent(new Event(`${this.selectType}SelectionCleared`, {
            detail: {},
            bubbles: true // This needs to be explicitly set to enable event bubbling
        }));
    }

    handleParentCleared(event) {


        // Clear this select
        updateSelect(this.element.id, []);
    }

    _setParent(parent) {
        this.parent = parent;
    }

    _setSelectType(selectType) {
        this.selectType = selectType;
    }
}